import { useMediaQuery } from '@material-ui/core';
import { Sidebar } from 'components/Sidebar';
import { Header } from 'components/Header';
import React, { Suspense, useState } from 'react';
import theme from 'theme';
import { Backdrop } from '@room-match/shared-ui-components';

import { useStyles } from './ClientLayout.styles';
import { ClientSidebar } from '../ClientSidebar';
import { ClientHeader } from '../ClientHeader';

type Props = {
  children: React.ReactNode;
};
const ClientLayout: React.FC<Props> = ({ children }) => {
  const classes = useStyles();
  const screenLarge = useMediaQuery(theme.breakpoints.up('md'), {
    noSsr: true,
  });
  const [isMobileDrawerOpen, setIsMobileDrawerOpen] = useState(false);
  const [isDrawerCollapse, setIsDrawerCollapse] = useState(!screenLarge);
  const handleMobileDrawer = () => {
    setIsMobileDrawerOpen(!isMobileDrawerOpen);
  };

  const toggleDrawerCollapse = () => {
    setIsDrawerCollapse((isCollapse) => !isCollapse);
  };

  return (
    <div className={classes.root}>
      <ClientHeader handleDrawerToggle={handleMobileDrawer} isDrawerCollapse={isDrawerCollapse} />
      <ClientSidebar
        handleMobileDrawer={handleMobileDrawer}
        isMobileDrawerOpen={isMobileDrawerOpen}
        isDrawerCollapse={isDrawerCollapse}
        toggleDrawerCollapse={toggleDrawerCollapse}
      />

      <main className={classes.content}>
        <div className={classes.toolbar} style={{ minHeight: '60px' }} />
        <Suspense fallback={<Backdrop isLoading={true} />}>
          <>{children}</>
        </Suspense>
      </main>
    </div>
  );
};

export default ClientLayout;
